<template>
  <tree-select
    ref="treeSelect"
    :props="props"
    :options="data"
    :value="value1"
    :parent-select="pSelect"
    :clearable="false"
    placeholder="请选择"
    :disabled="disabled"
    @node-select="select($event)"
  />
</template>
<script>
import treeSelect from "@/components/common/treeSelect";
export default {
  components: { treeSelect },
  props: {
    value: {},
    pSelect: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
     api: require("@/api/ba/class").default,
      value1: null,
      data: [],
      props: {
        // 配置项（必选）
        value: "ClassId",
        label: "ClassName",
        children: "children",
      },
    };
  },
  mounted() {
    this.value1 = this.value;
    // console.log("mounted", this.value1);
    this.init();
  },
  watch: {
    value() {
      this.value1 = this.value;
      console.log("watch", this.value1);
    },
  },
  methods: {
    init(params = {}) {
      let data = JSON.parse(localStorage.getItem('shebeiList'));
      if(data.length !== 0){
        this.data = data;
        this.$refs.treeSelect?.setData();
      }else{
        params = { ...params, Status: 1, ClassType: 9 };
        this.api.list(params).then((res) => {
          this.data = this.$commonJs.toTreeData(res.Data, "ClassId");

          this.$refs.treeSelect?.setData();
        });
      }
      
    },
    clear() {
      this.$refs.treeSelect.clearHandle();
    },
    select(e) {
      if (e) this.$emit("input", e.ClassId);
      else this.$emit("input", null);
    },
  },
};
</script>